export const uuidToId = (uuid: string) => uuid.replaceAll('-', '')
